import { Pipe, PipeTransform } from '@angular/core';
import { GridFormatService } from "../services";

@Pipe({
    name: "gridCurrency",
    standalone: false
})
export class GridCurrencyPipe implements PipeTransform
{
    constructor(
        private $gridFormatService: GridFormatService
    ) {}

    transform(value: any, column: any): any
    {
        return this.$gridFormatService.currencyFormatter(value, column);
    }
}
